require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bucklescript-tea.json") })
        }
      }, "path---package-bucklescript-tea");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bucklescript-tea!./.cache/json/package-bucklescript-tea.json
// module id = 855
// module chunks = 231608221292675